/* @flow */
// typecheck: ignore file
import cx from 'classnames';
import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { throttle } from 'lodash';

import DOM from 'lib/DOM';

import './styles/ScrollableArea.scss';

const ScrollableArea = React.createClass({
  // $FlowIssue
  propTypes: {
    scrollToBottom: React.PropTypes.bool,
    showShadows: React.PropTypes.bool,
    onScroll: React.PropTypes.func,
    useBodyChildrenHeight: React.PropTypes.bool,
    children: React.PropTypes.node.isRequired,
    alignBottom: React.PropTypes.bool,
  },

  childContextTypes: {
    scrollableArea: React.PropTypes.object,
  },

  getDefaultProps() {
    return {
      scrollToBottom: false,
      showShadows: false,
      useBodyChildrenHeight: false,
      alignBottom: false,
    };
  },

  getInitialState() {
    return {
      scrollHeight: 0,
      scrollBottom: 0,
      scrollTop: 0,
      scrolledToBottom: this.props.scrollToBottom,
      scrolledToTop: !this.props.scrollToBottom,
    };
  },

  getChildContext() {
    return {
      scrollableArea: this,
    };
  },

  componentDidMount() {
    this.handleScroll = throttle(this.handleScroll, 100);
    if (this.props.scrollToBottom) {
      this.scrollToBottom();
    }
    this.updateHeight();
  },

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    return shallowCompare(this, nextProps, nextState);
  },

  componentWillUpdate() {
    const { body } = this.refs;
    this.prevScrolledHeight = body.scrollHeight;
    this.prevScrollTop = body.scrollTop;
  },

  componentDidUpdate(prevProps: Object) {
    if (this.props.scrollToBottom) {
      if (this.state.scrolledToBottom) {
        this.scrollToBottom();
      } else if (this.props.children !== prevProps.children) {
        const { body } = this.refs;
        body.scrollTop = this.prevScrollTop + (body.scrollHeight - this.prevScrolledHeight);
      }
    }

    if (this.props.children !== prevProps.children ||
        ((this.props.style && prevProps.style) &&
          (this.props.style.height !== prevProps.style.height))) {
      this.updateHeight();
    }
  },

  prevScrollTop: 0,
  prevScrolledHeight: 0,

  // TODO: Look into why body is using absolute positioning to replace this workaround
  getScrollHeight() {
    const { body } = this.refs;

    let scrollHeight;
    if (this.props.useBodyChildrenHeight) {
      const children = Array.prototype.slice.call(body.children);
      scrollHeight = children.map(child => child.scrollHeight)
        .reduce((prev, curr) => prev + curr, 0);
    } else {
      scrollHeight = body.scrollHeight;
    }

    // Account for the parents border (assumes equal border width on all sides)
    const parentBorderWidth = DOM.getStyle(body.parentNode, 'border-width');
    if (parentBorderWidth) {
      scrollHeight += 2 * parseInt(parentBorderWidth, 10);
    }

    return scrollHeight;
  },

  handleScroll() {
    if (this.refs.body) {
      this.updateScrollPositions(this.props.onScroll);
    }
  },

  handleWheel(event: SyntheticWheelEvent) {
    if (!this.isMounted()) {
      return;
    }

    if (event.deltaX && !event.deltaY) {
      return;
    }

    // This prevents mousewheel events on ScrollableArea instances from transferring to mousewheel
    // on the document's main scroll area.
    const delta = -event.deltaY;
    const node = this.refs.body;
    if (!node) {
      return;
    }
    const scrollHeight = node.scrollHeight;
    const clientHeight = node.clientHeight;
    if (scrollHeight > clientHeight) {
      const scrollTop = node.scrollTop;
      if ((delta > 0 && scrollTop === 0) ||
          (delta < 0 && scrollTop >= scrollHeight - clientHeight - 1)) {
        event.preventDefault();
      }
    }
  },

  isScrolledToBottom(offset: number = 0) {
    return this.state.scrollBottom + offset >= 0;
  },

  isScrolledToTop(offset: number = 0) {
    return this.state.scrollTop - offset <= 0;
  },

  scrollIntoView(node: HTMLElement) {
    const { body } = this.refs;
    const position = DOM.getPosition(node, body);
    if (position.top < 0) {
      body.scrollTop += position.top;
    } else if (position.top + node.offsetHeight > body.offsetHeight) {
      body.scrollTop += position.top + node.offsetHeight - body.offsetHeight;
    }
  },

  scrollIntoViewCenter(node: HTMLElement) {
    const { body } = this.refs;
    const position = DOM.getPosition(node, body);
    body.scrollTop += position.top - (body.offsetHeight - node.offsetHeight) / 2;
  },

  scrollToBottom() {
    const { body } = this.refs;
    body.scrollTop = body.scrollHeight;
  },

  scrollToTop() {
    const { body } = this.refs;
    body.scrollTop = 0;
  },

  updateHeight() {
    this.setState({
      scrollHeight: this.getScrollHeight(),
    }, () => {
      // If the component is re-rendered before this is called, the refs become undefined.
      if (this.refs.body) {
        this.updateScrollPositions();
      }
    });
  },

  updateScrollPositions(callback: ?Function) {
    const { body } = this.refs;
    const scrollTop = body.scrollTop;
    const scrollBottom = scrollTop + body.offsetHeight - body.scrollHeight;
    this.setState({
      scrollTop,
      scrollBottom,
      scrolledToBottom: scrollBottom === 0,
      scrolledToTop: scrollTop === 0,
    }, callback || undefined);
  },

  render() {
    const { alignBottom, className, style, showShadows, children } = this.props;

    return (
      <div
        className={cx({
          ScrollableArea: true,
          'ScrollableArea-hasContentAbove': showShadows && !this.state.scrolledToTop,
          'ScrollableArea-hasContentBelow': showShadows && !this.state.scrolledToBottom,
        }, className)}
        style={Object.assign({ height: this.state.scrollHeight }, style)}>
        <div
          ref="body"
          className={cx({
            'ScrollableArea-body': true,
            'ScrollableArea-body-bottom': alignBottom,
          })}
          onScroll={this.handleScroll}
          onWheel={this.handleWheel}>
          {children}
        </div>
      </div>
    );
  },
});

export default ScrollableArea;



// WEBPACK FOOTER //
// ./src/components/ScrollableArea.jsx